import script from "./IcLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./IcLoader.vue?vue&type=script&setup=true&lang=js"

import "./IcLoader.vue?vue&type=style&index=0&id=e0a0ba64&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0a0ba64"]])

export default __exports__